import { ZoomInIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVInspectionArea } from 'types'

const StyledZoomIcon = styled(ZoomInIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const ZoomToInspectionAreaButton: FC<{
  inspectionArea: KVInspectionArea
}> = ({ inspectionArea }) => {
  const { sendKVCommand, setSelectedMarkup } = useKestrel()

  const zoomToInspectionArea = (e: React.MouseEvent) => {
    e.stopPropagation()
    setSelectedMarkup(undefined)
    if (sendKVCommand) {
      sendKVCommand({
        command: KestrelCommands.ZOOM_TO_LOCATION,
        inspectionAreaId: inspectionArea.id,
        position: inspectionArea.centroid,
        normal: inspectionArea.normal,
      })
    }
  }

  return (
    <TooltipWrapper label='View inspection area' side='top'>
      <div
        style={{ cursor: 'pointer' }}
        onClick={(e) => zoomToInspectionArea(e)}>
        <StyledZoomIcon width={22} height={22} />
      </div>
    </TooltipWrapper>
  )
}
